import { connect } from 'react-redux';
import { AppState } from '../../../../../types/store';
import { getModuleData } from '../../../../selectors/modules';
import { getProfileOwnerUser } from '../../../../selectors/users';
import { getDeviationsByIds } from '@wix/da-shared-react/pkg/redux/deviations/selectors';

export default connect(
  (state: AppState, ownProps) => {
    const moduleData = getModuleData(state, ownProps.moduleId);
    const {
      title,
      hasMore,
      seeAllUrl,
      deviations: deviationIds = [],
    } = moduleData;

    return {
      streamId: `exhibitionist-${ownProps.moduleId}`,
      title,
      seeAllUrl,
      hasMore,
      deviations: getDeviationsByIds(state, deviationIds).filter(
        deviation => deviation
      ),
      isEmpty: !deviationIds.length,
      profileOwnerUser: getProfileOwnerUser(state),
    };
  },
  {}
);
